import * as React from 'react';
import { CloseIcon, DeviceIcon } from 'components/src/svg';
import { LogoEye } from 'components/src/svg';
import { Paragraph, Subheading } from 'components/src/typography';
import { colors } from 'components/src/foundation';
import { Link } from 'components/src/link';
import { Maybe } from 'types/generated';
import { formatLink, cleanLink } from '@/utils/utils';
import PhonenumberInput from '../common/PhoneNumberInput';
import NextLink from 'next/link';
import { SMSResponseState } from '../2fyrir1/Utils';

type Props = {
  subTitle?: Maybe<string>;
  title: string;
  link?: Maybe<string>;
  phoneNumber?: Maybe<string>;
  onClose: () => void;
  onPhonenumberChange: (value: string) => void;
  infoText?: string | null;
  footerSection: React.ReactNode;
  state?: SMSResponseState | null;
};

const CouponCard = ({
  subTitle,
  title,
  phoneNumber,
  link,
  onClose,
  onPhonenumberChange,
  infoText,
  footerSection,
  state,
}: Props) => {
  return (
    <div className="max-w-[328px] rounded-28">
      <div className="flex justify-between rounded-t-28 bg-red-100 p-16">
        <LogoEye variant="inverted" />
        <button onClick={onClose}>
          <CloseIcon color={colors.primary.white} />
        </button>
      </div>
      <div className="flex flex-col items-center justify-center bg-white-100 px-16 py-24 text-center sm:px-32 sm:py-32">
        {subTitle && <Subheading classes="title-lg mb-4 text-black-50">{subTitle}</Subheading>}
        <Subheading classes="label-lg text-black-50">{title}</Subheading>
        <div className="mt-16 grid gap-y-8">
          {link && <Link label={cleanLink(link)} href={formatLink(link)} iconPosition="right" />}
          {phoneNumber && (
            <div className="flex gap-x-4 [&>svg]:my-auto">
              <DeviceIcon />
              {
                <NextLink
                  href={phoneNumber.includes('tel:') ? phoneNumber : `tel:${phoneNumber}`}
                  className="hover:underline"
                >
                  <Paragraph variant="small">{phoneNumber.replace('tel:', '')}</Paragraph>
                </NextLink>
              }
            </div>
          )}
        </div>
        <div className="mt-32 grid gap-12 self-stretch">
          {state !== 'success' && (
            <PhonenumberInput
              id={'simanumer'}
              name={'simanumer'}
              placeholder={'Sláðu inn símanúmer'}
              onChange={(value) => onPhonenumberChange(value)}
              classes="w-full text-center"
            />
          )}
          {infoText && <Subheading classes="body-md text-black-50">{infoText}</Subheading>}
        </div>
      </div>
      <div className="flex flex-col items-center justify-end rounded-b-28 bg-white-100 p-sm pt-0 text-center md:p-sm">
        {footerSection}
      </div>
    </div>
  );
};
export default CouponCard;
